import { Button, Flex, Modal, Typography, useToast } from '@iheartjane/reefer';
import { useEffect } from 'react';

import { useUpdateBulkProductsAsync } from '@jane/business-admin/data-access';
import { useStoreId } from '@jane/business-admin/hooks';

interface ClearModalProps {
  onBulkEditModalClose: () => void;
  onClose: () => void;
  open: boolean;
}

export const ClearModal = ({
  open,
  onClose,
  onBulkEditModalClose,
}: ClearModalProps) => {
  const toast = useToast();
  const storeId = useStoreId();
  const {
    mutateAsync: bulkUpdateProductsAsync,
    isPending: bulkUpdateProductsLoading,
    isSuccess: bulkUpdateProductsSuccess,
    isError: bulkUpdateProductsError,
  } = useUpdateBulkProductsAsync(storeId);

  useEffect(() => {
    if (bulkUpdateProductsSuccess) {
      onClose();
      onBulkEditModalClose();
      toast.add({
        label:
          'Update submitted! Depending on your product count, it may take up to a few minutes. You can safely navigate away.',
        variant: 'success',
      });
    }
  }, [bulkUpdateProductsSuccess]);

  useEffect(() => {
    if (bulkUpdateProductsError) {
      toast.add({
        label: 'Bulk update failed!',
        variant: 'error',
      });
    }
  }, [bulkUpdateProductsError]);

  const onSubmit = () => {
    const clearData: Record<any, any> = {
      percent_cbd: null,
      percent_cbda: null,
      percent_thc: null,
      percent_thca: null,
    };

    bulkUpdateProductsAsync({
      allProducts: true,
      data: clearData,
      productIds: [],
    });
  };

  const handleDismiss = () => {
    onClose();
  };

  return (
    <Modal
      onRequestClose={onClose}
      open={open}
      variant="dialogue"
      appId="parent"
    >
      <Modal.Content>
        <Flex
          width="100%"
          minWidth={512}
          flexDirection="column"
          alignItems="center"
        >
          <Typography variant="h1-semibold" mb={16}>
            Clear potencies
          </Typography>
          <Typography textAlign="center" mb={24}>
            You are about to clear potencies for all of this store's in-stock
            and out-of-stock products on Jane.
          </Typography>

          <Flex width="100%">
            <Button
              mr={16}
              full
              variant="tertiary"
              label="Dismiss"
              onClick={handleDismiss}
            />
            <Button
              mr={16}
              full
              variant="primary"
              label="Confirm"
              data-testid="confirm-clear-button"
              onClick={onSubmit}
              loading={bulkUpdateProductsLoading}
            />
          </Flex>
        </Flex>
      </Modal.Content>
    </Modal>
  );
};
